// 业务环境
export const DEPLOY_ENV = process.env.VUE_APP_DEPLOY_ENV
// 运行环境
export const NODE_ENV = process.env.NODE_ENV
// 版本
export const VERSION = process.env.VUE_APP_VERSION

const clientWidth =
  document.documentElement.clientWidth || document.body.clientWidth

const widthFixed = clientWidth > 768 ? 668 : clientWidth

export const WIDTH = widthFixed
